// src/presentation/pages/ClinicalExamination/Step3BehavioralAssessment.tsx
import React from "react";
import { SleepQualitySection } from "./sections/SleepQualitySection";
import { DepressionSection } from "./sections/DepressionSection";
import { AnxietySection } from "./sections/AnxietySection";
import { ApathySection } from "./sections/ApathySection";
import type { BehavioralFormData } from "./types";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface Step3BehavioralAssessmentProps {
  formData: BehavioralFormData;
  onFormDataChange: (data: BehavioralFormData) => void;
  onSkip?: () => void;
}

const Step3BehavioralAssessment: React.FC<Step3BehavioralAssessmentProps> = ({
  formData,
  onFormDataChange,
  onSkip,
}) => {
  const { t } = useTranslation("patients");
  const updateFormData = (updates: Partial<BehavioralFormData>) => {
    onFormDataChange({ ...formData, ...updates });
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col">
        <p className="text-[#5F646F] text-sm"> {t("clinicalSections.step3.stepLabel")}</p>
        <div className="flex flex-col gap-2 sm:flex-row sm:justify-between">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <h3 className="text-lg font-bold text-gray-900">
              {t("clinicalSections.step3.title")}
            </h3>
            <div className="bg-[#D4DAEB] p-2 rounded">
              <p className="">{t("clinicalSections.step3.answeredByCaregiver")}</p>
            </div>
          </div>
          <Button
            variant="link"
            onClick={onSkip}
            className="hover:text-primary cursor-pointer"
          >
            {t("clinicalSections.step3.skip")}
          </Button>
        </div>
      </div>

      {/* Sleep Quality Section */}
      <SleepQualitySection
        value={formData.sleepQuality}
        onChange={(value) => updateFormData({ sleepQuality: value })}
      />
      <Separator />

      {/* Depression Section */}
      <DepressionSection
        value={formData.depressionFrequency}
        onChange={(value) => updateFormData({ depressionFrequency: value })}
      />
      <Separator />

      {/* Anxiety Section */}
      <AnxietySection
        value={formData.anxietyLevel}
        onChange={(value) => updateFormData({ anxietyLevel: value })}
      />
      <Separator />
      {/* Apathy Section */}
      <ApathySection
        value={formData.apathyLevel}
        onChange={(value) => updateFormData({ apathyLevel: value })}
      />
    </div>
  );
};

export default Step3BehavioralAssessment;
